import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { Close, Business, Save, CheckCircle } from '@material-ui/icons';
import SelectModal from './SelectModal';

function AddModal({ show, fields, values }) {

    console.log('changing')

    const [isSelect, setIsSelect] = useState(false)
    const [toSelect, setToSelect] = useState([])
    const [selecting, setSelecting] = useState(null)

    function onClose() {

        console.log(fields)

        fields.forEach((field, index) => {

            if (field.component === 'check') {
                values[field.name] = document.getElementById(`empresa[${index}].${field.name}`).checked
            } else {
                values[field.name] = document.getElementById(`empresa[${index}].${field.name}`).value
            }

        })

        console.log(values)

    }

    return (
        <Overlay onClick={() => show(false)}>
            {
                isSelect && <SelectModal
                    title={'Selecionar Empresa'}
                    items={toSelect}
                    selected={null}
                    onSelect={(item) => {
                        document.getElementById(selecting).value = item.value
                        document.getElementById(`${selecting}-label`).value = item.label
                        setIsSelect(false)
                        setToSelect([])
                    }}
                    onClose={() => {
                        setIsSelect(false)
                        setToSelect([])
                    }}
                />
            }
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalHeader>
                    <HeaderLeft>
                        <HeaderIcon>
                            <Business />
                        </HeaderIcon>
                        <HeaderTitle>Configurar Empresa</HeaderTitle>
                    </HeaderLeft>
                    <CloseButton onClick={() => show(false)}>
                        <Close />
                    </CloseButton>
                </ModalHeader>

                <ModalBody>
                    {
                        fields.map((field, index) => (
                            <FieldContainer key={index}>
                                <FieldLabel>{field.label}</FieldLabel>
                                {
                                    field.component === 'select' ?
                                        <>
                                            <HiddenInput
                                                id={`empresa[${index}].${field.name}`}
                                                defaultValue={values[field.name]}
                                            />
                                            <SelectInput
                                                id={`empresa[${index}].${field.name}-label`}
                                                defaultValue={values[field.name] ? field.options.find(i => i.value === values[field.name])?.label : ''}
                                                placeholder={`Selecione ${field.label.toLowerCase()}`}
                                                onClick={() => {
                                                    setSelecting(`empresa[${index}].${field.name}`)
                                                    setIsSelect(true)
                                                    setToSelect(field.options)
                                                }}
                                                readOnly
                                            />
                                        </>
                                        :
                                        field.component === 'check' ?
                                            <CheckboxContainer>
                                                <CheckboxWrapper>
                                                    <StyledCheckbox
                                                        id={`empresa[${index}].${field.name}`}
                                                        type="checkbox"
                                                        defaultChecked={values[field.name]}
                                                    />
                                                    <CheckboxLabel htmlFor={`empresa[${index}].${field.name}`}>
                                                        <CheckCircle style={{ fontSize: '18px', marginRight: '6px' }} />
                                                        {values[field.name] ? 'Habilitado' : 'Desabilitado'}
                                                    </CheckboxLabel>
                                                </CheckboxWrapper>
                                            </CheckboxContainer>
                                            :
                                            <ModernInput
                                                id={`empresa[${index}].${field.name}`}
                                                type="text"
                                                defaultValue={values[field.name]}
                                                placeholder={`Digite ${field.label.toLowerCase()}`}
                                            />
                                }
                            </FieldContainer>
                        ))
                    }
                </ModalBody>

                <ModalFooter>
                    <FooterButton
                        variant="secondary"
                        onClick={e => {
                            e.preventDefault();
                            show(false)
                        }}
                    >
                        <Close style={{ marginRight: '8px', fontSize: '20px' }} />
                        Cancelar
                    </FooterButton>
                    <FooterButton
                        variant="primary"
                        onClick={e => {
                            e.preventDefault();
                            onClose()
                            show(false)
                        }}
                    >
                        <Save style={{ marginRight: '8px', fontSize: '20px' }} />
                        Salvar
                    </FooterButton>
                </ModalFooter>
            </ModalContent>
        </Overlay>
    )

}

// Animações
const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0.95);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: ${fadeIn} 0.3s ease;
    backdrop-filter: blur(4px);
`;

const ModalContent = styled.div`
    background: white;
    border-radius: 20px;
    width: 90%;
    max-width: 600px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: ${slideIn} 0.4s ease;
    overflow: hidden;
    font-family: 'Mulish', sans-serif;

    @media (max-width: 768px) {
        width: 95%;
        max-height: 90vh;
    }
`;

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 28px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-bottom: none;
`;

const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const HeaderIcon = styled.div`
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);

    svg {
        font-size: 24px;
    }
`;

const HeaderTitle = styled.h2`
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    font-family: 'Mulish', sans-serif;
`;

const CloseButton = styled.button`
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 10px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: rotate(90deg);
    }

    svg {
        font-size: 22px;
    }
`;

const ModalBody = styled.div`
    padding: 28px;
    overflow-y: auto;
    flex: 1;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: #667eea;
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #764ba2;
    }
`;

const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
`;

const FieldLabel = styled.label`
    font-size: 14px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-family: 'Mulish', sans-serif;
`;

const ModernInput = styled.input`
    width: 100%;
    height: 44px;
    border: 2px solid #e8e8e8;
    border-radius: 12px;
    padding: 0 16px;
    font-size: 14px;
    font-family: 'Mulish', sans-serif;
    color: #2c3e50;
    transition: all 0.3s ease;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #667eea;
        box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
    }

    &::placeholder {
        color: #95a5a6;
    }

    &:hover {
        border-color: #d0d0d0;
    }
`;

const SelectInput = styled(ModernInput)`
    cursor: pointer;
    background: white;

    &:hover {
        background: #f8f9fa;
    }
`;

const HiddenInput = styled.input`
    display: none;
`;

const CheckboxContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: #f8f9fa;
    border-radius: 12px;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
        background: rgba(102, 126, 234, 0.1);
    }
`;

const StyledCheckbox = styled.input`
    width: 20px;
    height: 20px;
    margin-right: 12px;
    cursor: pointer;
    accent-color: #667eea;
`;

const CheckboxLabel = styled.label`
    font-size: 14px;
    font-weight: 500;
    color: #2c3e50;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-family: 'Mulish', sans-serif;
`;

const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 28px;
    background: #f8f9fa;
    border-top: 1px solid #e8e8e8;
`;

const getButtonVariantStyles = (variant) => {
    const variants = {
        primary: `
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            &:hover {
                box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
            }
        `,
        secondary: `
            background: white;
            color: #667eea;
            border: 2px solid #667eea;
            &:hover {
                background: #667eea;
                color: white;
                box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
            }
        `,
    };
    return variants[variant] || variants.primary;
};

const FooterButton = styled.button`
    padding: 12px 24px;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    font-family: 'Mulish', sans-serif;
    ${({ variant }) => getButtonVariantStyles(variant)}

    &:hover {
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
    }
`;

export default React.memo(AddModal);